import { GegevensWerknemerDto } from '../../../api';
import { documentApi } from '../../../api/apiClient';
import { FormulierProcessDependencies } from '../dependencies';

export const addToCsv = async (values: any, deps: FormulierProcessDependencies) => {
  deps.dispatch(s => ({ ...s, isLoading: true }));

  const data: GegevensWerknemerDto = values;

  try {
    await documentApi.documentAddToCsv(data);
    deps.dispatch(s => ({
      ...s,
      isLoading: false,
    }));
  } catch (e) {
    deps.dispatch(s => ({
      ...s,
      isLoading: false,
      isComplete: false,
    }));
  }
};
